import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled',
    useHash: false,
};

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'modulos' },
    // { path:'**',pathMatch:'full',redirectTo:'notfound' },
    { path: 'landing', loadChildren: () => import('./components/landing/landing.module').then((m) => m.LandingModule), },
    { path: 'modulos', loadChildren: () => import('./components/modulos/modulos.module').then((m) => m.ModulosModule), },
   { path: '**', loadChildren: () => import('./components/notfound/notfound.module').then((m) => m.NotfoundModule), },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions,)],
    exports: [RouterModule],
})
export class AppRoutingModule { }
